import color from "../../constants/color";

const styles = {
  container:{
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    justifyContent:"space-between"},
  pagination: {
    mt:0,
    "& .css-18ifh2m-MuiStack-root>:not(style)~:not(style)" :{
      marginTop: "0px !important",
    },
    "& .MuiPagination-ul":{
      margin:"20px",
      mt: "8px",
      width:"max-content"},
    "& .css-1tlosx4-MuiButtonGroup-root .MuiButton-containedPrimary": {
      fontSize: "14px",
      fontWeight: "400",
    },
    "& .css-kt6qzs-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected": {
      backgroundColor:color.secondary,
      color:color.card
    }, "& .Mui-selected": {
      backgroundColor:color.secondary,
      color:color.card
    },"& .MuiPaginationItem-previousNext":{
      backgroundColor:color.primary,
      color:color.card
    }
  },
  show:{
    ml:"20px",
    mr: "10px",
    fontSize: "14px",
    fontWeight: "500",

  },
  button:{
    color:color.text
  },

  showBox:{
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
  },
  row: {
    height: "2.2em", 
    width:"fit-content", 
    borderRadius: "50px",
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    border: "1px solid #DEDEDE",
    p: 2
  }
};
export default styles;